module.exports = __webpack_public_path__ + "img/background.df52f238.png";